module.exports = __webpack_public_path__ + "infocentrum2.jpg?0d26f49d06a90350f5188ddfebc61af9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum2.jpg
// module id = 254
// module chunks = 0